import { uniqueId } from 'lodash';
import { url } from 'configs/';
import notificationIcon from '../../images/links/py/icn_payroll_notification.png';
const baseUrl = url.PY_API_SERVER;
const module = 'PY';
export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_MyPayslip',
    icon: notificationIcon,
    url: '/payroll/salarysearchprint',
    messageApi: `${baseUrl}PayrollNotices/MessageCount`,
    sort: 15,
    functionCode: 'PersonalInfoSearchPrint',
  },
];



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/config/links/py.js
 **/